import { injectAxios } from '@/lib/axios/Axios';

type SyncIdsPayload = {
  email: string;
  userId: string;
  companyId: string;
  contactId?: string;
  contactCountry?: string;
  country?: string;
};

type SyncIdsResponse =
  | { status: 'success'; contactId: string; attempts: number }
  | { status: 'error'; error: string; attempts: number };

class HubspotSyncRequests {
  private static readonly axiosInstance = injectAxios('/api');

  static async syncIds(payload: SyncIdsPayload): Promise<SyncIdsResponse> {
    const { data } = await this.axiosInstance.post<SyncIdsResponse>(
      '/hubspot-sync-ids',
      payload,
    );
    return data;
  }
}

export default HubspotSyncRequests;
